module.exports = __webpack_public_path__ + "img/cu-blanco.b18a7bcd.svg";